import React, { useState } from 'react';
import { Box, useTheme, useMediaQuery, Typography, Button } from '@mui/material';
import Sales from '../../components/Table/Mobile/Sales';
import { CircularProgressCustom, FormPaymentType, Modal } from '../../components';
import { STATUS_SALE } from '../../helpers/enums';

const OPERATION_ITEM = {
    completingSale: 'completingSale',
    deleteItem: 'deleteItem',
    reserveItem: 'reserveItem'
}

const createPaymentTemplate = (paymentTypes = []) =>
  (paymentTypes || []).map((pt) => ({
    _id: pt?._id,
    name: pt?.name || 'Medio de pago',
    description: pt?.description || '',
    applies_surcharge: Boolean(pt?.applies_surcharge),
    installments: Array.isArray(pt?.installments) ? pt.installments : [],
    amount: 0,
  }));

const paymentTypeKey = (paymentType = {}) => paymentType?._id || paymentType?.name;

const CompletingSale = ({ salesChecked, onAcept, onCancel, paymentTypes = [], storeId }) => {
  const grouped = salesChecked?.reduce((acc, item) => {
    if (!acc[item.nameSale]) {
      acc[item.nameSale] = [];
    }
    acc[item.nameSale].push(item);
    return acc;
  }, {});
  const saleGrouped = Object.entries(grouped).map(([nameSale, sales]) => ({
    saleIds: sales.map(s => s._id),
    nameSale: nameSale,
    total: sales.reduce((sum, sale) => sum + (sale.quantity_sold * sale.prices_sold.sale_price) - sale.deposit, 0),
    amount: sales.reduce((sum, sale) => sum + (sale.payments ? sale.payments.reduce((sum, p) => sum + p.amount, 0) : 0), 0),
    paymenttypes: structuredClone(createPaymentTemplate(paymentTypes))
  }))

  return <Box padding={2}>
    <FormPaymentType
      payments={saleGrouped}
      onSubmit={onAcept}
      onClose={onCancel}
      storeId={storeId}
    />

  </Box>
}

const ConfirmationItem = ({ Tittle, onAcept, onCancel }) =>  <Box padding={2}>
  <Tittle />
  <Box sx={{ mt: 5, display: "flex" }} flexDirection='row' justifyContent='space-between'>
    <Button
      type="submit"
      variant="outlined"
      onClick={onCancel}
    >Cancelar</Button>
    <Button
      type="submit"
      variant="outlined"
      onClick={onAcept}
    >
      Confirmar
    </Button>
  </Box>
</Box>

const VentasView = ({ 
  salesReserved,
  loading,
  saving,
  users,
  onCompleteSales,
  onDeleteItem,
  onReserveItem,
  onAddDeposit,
  onAddItems,
  asList,
  paymentTypes = [],
  readonly = false,
  storeId,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [operationItem, setOperationItem] = useState("");
  const [saleSelected, setSaleSelected] = useState(null);
  const [salesGroup, setSalesGroup] = useState(null);
  const [salesChecked, setSalesChecked] = useState([]);

  const handleDeleteItem = (sale, sales) => {
      console.log(sale);
      setOperationItem("deleteItem")
      setSaleSelected(sale);
      setSalesGroup(sales)
      setOpenModalConfirmation(!openModalConfirmation);
  }

  const handleReserveItem = sale => {
      console.log(sale);
      setOperationItem("reserveItem")
      setSaleSelected(sale);
      setOpenModalConfirmation(!openModalConfirmation);
  }

  const hanldeCompleteOrders = async (orders, status) => {
    if (orders) {
      var salesChecked = Object.values(orders).filter(order => order.checked).flatMap(item => item.sales);
      if (status === STATUS_SALE.FINISHED) {
        if (!paymentTypes.length) {
          return;
        }
        setSalesChecked(salesChecked);
        setOperationItem("completeSale")
        setOpenModalConfirmation(true);
      } else {
        onCompleteSales && onCompleteSales(status, salesChecked);
      }
    }
  }

  const hanldeCompleteSales = async ({ payments } = {}) => {
    setOpenModalConfirmation(false);

    const safePayments = Array.isArray(payments) ? payments : [];

    const distributionByGroup = safePayments.reduce((acc, groupPayment) => {
      const saleIds = groupPayment?.saleIds || [];
      if (!saleIds.length) return acc;

      const types = Array.isArray(groupPayment?.paymenttypes) ? groupPayment.paymenttypes : [];
      const remainingByType = types.reduce((typeAcc, p) => {
        const key = paymentTypeKey(p);
        if (!key) return typeAcc;
        typeAcc[key] = Number(p?.amount || 0);
        return typeAcc;
      }, {});

      acc[saleIds.join('|')] = {
        saleIds,
        typeOrder: types.map((p) => paymentTypeKey(p)).filter(Boolean),
        remainingByType,
        paymentsTemplate: types.map((p) => ({ ...p, amount: 0 })),
      };

      return acc;
    }, {});

    const distributedSales = salesChecked.map((sale) => {
      const saleTotal = Number(sale?.quantity_sold || 0) * Number(sale?.prices_sold?.sale_price || 0);
      const deposit = Number(sale?.deposit || 0);
      const pending = Math.max(saleTotal - deposit, 0);

      const groupKey = Object.keys(distributionByGroup).find((key) => distributionByGroup[key].saleIds.includes(sale._id));
      const group = groupKey ? distributionByGroup[groupKey] : null;

      const basePayments = group
        ? structuredClone(group.paymentsTemplate)
        : structuredClone(createPaymentTemplate(paymentTypes));

      if (!group || pending <= 0) {
        return {
          ...sale,
          payments: basePayments,
        };
      }

      let remainingPending = pending;

      group.typeOrder.forEach((typeKey) => {
        if (remainingPending <= 0) return;
        const remainingTypeAmount = Number(group.remainingByType[typeKey] || 0);
        if (remainingTypeAmount <= 0) return;

        const assigned = Math.min(remainingTypeAmount, remainingPending);
        group.remainingByType[typeKey] = remainingTypeAmount - assigned;
        remainingPending -= assigned;

        const paymentIndex = basePayments.findIndex((p) => paymentTypeKey(p) === typeKey);
        if (paymentIndex >= 0) {
          basePayments[paymentIndex].amount = assigned;
        }
      });

      return {
        ...sale,
        payments: basePayments,
      };
    });

    onCompleteSales && onCompleteSales(STATUS_SALE.FINISHED, distributedSales, safePayments);
  }

  return (<Box display='flex' flexDirection='column' sx={{ background: !isMobile ? '#F8F1E9' : null }} flex={1}>
    <Box
      display='flex'
      flexDirection='column'
      justifyContent={!isMobile && loading ? 'center' : 'space-between'}
      width='100%'
      flex='1'
      padding={1}
      alignItems={!isMobile && loading ? 'center' : null}
    >
      {loading || saving ? <CircularProgressCustom size={150} /> :
        <Sales
          users={users}
          salesData={salesReserved}
          onCompleteSales={readonly ? undefined : hanldeCompleteOrders}
          onDeleteItem={readonly ? undefined : handleDeleteItem}
          onReserveItem={readonly ? undefined : handleReserveItem}
          onAddDeposit={readonly ? undefined : onAddDeposit}
          onAddItems={readonly ? undefined : onAddItems}
          readonly={readonly}
          showImprimir
          asList
        />
      }
    </Box>
    <Modal
      open={openModalConfirmation}
      onClose={() => setOpenModalConfirmation(false)}
      Content={() => operationItem === OPERATION_ITEM.deleteItem ? 
        <ConfirmationItem 
          Tittle={() => <Typography><span>{`Seguro que desea eliminar el articulo ${saleSelected.article?.name} del pedido ${saleSelected.nameSale}?`}</span></Typography>} 
          onAcept={() => {
            setOpenModalConfirmation(false);
            onDeleteItem && onDeleteItem(saleSelected, salesGroup)
          }}
          onCancel={() => setOpenModalConfirmation(false)}
        /> 
        : operationItem === OPERATION_ITEM.reserveItem ? 
          <ConfirmationItem 
            Tittle={() => <Typography><span>{`Agregar seña para el pedido ${saleSelected.nameSale}?`}</span></Typography>}
            onAcept={() => {
              setOpenModalConfirmation(false);
              onReserveItem && onReserveItem(saleSelected)
            }}
            onCancel={() => setOpenModalConfirmation(false)}
          /> 
          : <CompletingSale 
              salesChecked={salesChecked}
              paymentTypes={paymentTypes}
              storeId={storeId}
              onAcept={hanldeCompleteSales}
              onCancel={() => setOpenModalConfirmation(false)}
            />}

    />
  </Box>
  )
}

export default VentasView;